module.exports = require("./lrc-IR.js");